import { appBasic } from "@/api/app.js";
import { setTheme,auth } from "common";

const app = {
  state: {
    appBasicData: null,//获取在应用管理端配置的应用基本信息
    appFlag: false,
  },
  mutations: {
    SET_APPINFO: (state, data) => {
      state.appBasicData = data;
    },
  },
  actions: {
    //获取在应用管理端配置的应用基本信息，配置应用系统图标、名称、主题色
    getAppInfo({ commit }) {
      return new Promise((resolve, reject) => {
        appBasic()
          .then((res) => {
            if (res.code === "00000") {
              let data = res.data;
              commit("SET_APPINFO", data);
              auth.saveAppStorage('app_basic',data)
              if (data.sysName) {
                document.title = data.sysName;
              }
              if (data.sysLogo2Url) {
                let logoLink = document.querySelector("#app_logo_link");
                if (data.sysLogo1Url) {
                  logoLink.href = data.sysLogo2Url;
                }
              }
              if (data.sysColour) {
                setTheme(data.sysColour);
              }
            } else {
              commit("SET_APPINFO", null);
            }
          })
          .catch(() => {
            commit("SET_APPINFO", null);
          });
      });
    },
  },
};
export default app;
